// extracted by mini-css-extract-plugin
export var planCard = "_ur-0";
export var planList = "_ur-1";